/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'

import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

import Stars from '../stars/stars.component'
import Disclaimer from '../disclaimer/disclaimer.component'
import Review from '../review/review.component'
import Highlights from '../highlights/highlights.component'
import List from '../list/list.component'
import More from '../more/more.component'

// TODO Set the correct article ID here
const ARTICLE_ID = '581130559761'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h3>
              <Stars rating={5} />
              Sterne für Zürich
            </h3>
            <h1>
              Dieser McDonald's und dieser Burger King brutzeln an ihren Gästen
              vorbei
            </h1>
            <h2>
              Ist ein Gast unzufrieden, schreibt er eine kritische
              Google-Bewertung. Wir haben die beiden am  schlechtesten
              bewerteten McDonald’s- und Burger-King-Restaurants besucht.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Simon Huwiler</div>
            {/* <div className='ta updated'>Aktualisiert am 31. XXXXXXX 2020</div> */}
          </div>
          <div className='ta text'>
            <p>
              Burger, das bedeutet zwischen zwei Brote gepackte Freiheit! Und
              obwohl ein Burgerrestaurant nach dem anderen in Zürich eröffnet,
              sind doch zwei Namen unweigerlich mit dieser
              ungesunden Köstlichkeit verbunden: McDonald’s und Burger King. 25
              Filialen mit dem gelben M und 19 Burger-King-Restaurants gibt es
              in Zürich.
            </p>

            <Disclaimer id='food' />

            <p>
              Aber nicht alle sind gleich gut – zumindest wenn man den
              Google-Bewertungen glaubt. Die jeweilige Filiale, die bei den
              Nutzerinnen und Nutzern durchgefallen ist, haben wir uns genauer
              angeschaut. An unterschiedlicheren Standorten könnten sie nicht
              sein: eine im Stadtzürcher Pendlerhotspot Stadelhofen, die andere
              in einem Ort, der nach Kühen klingt – sorry, Pfungen.
            </p>

            <h4>Buzzer King</h4>
            <p>
              In der Landgemeinde Pfungen bei Winterthur scheiterte bereits die
              Migros mit ihrer Chickeria. Im gleichen Gebäude versucht es nun
              Burger-King. Mitte August wurde die Filiale eröffnet und gemäss
              Google-Kritikern war der Start alles andere als ein Erfolg: Auf
              gerade einmal 2,1 von 5 möglichen Sternen schafft es der
              Burger-King-Neuzugang. Die Kritiker halten sich nicht zurück:
              «Reine Katastrophe!», heisst es etwa, oder «werde nie wieder bei
              Burger King essen». Falsches Essen geliefert, unmotiviertes
              Personal, kalte Speisen – eine Mängelliste des Grauens.
            </p>
            <p>Wir besuchen die Filiale.</p>
          </div>
        </div>
      </div>

      <div className='imagemiddle'>
        <img src={require('../../images/burgerking.jpg')} />
        <p className='bildunterschrift'>
          Hinter der Burger-King-Blache guckt noch der Chickeria-Schriftzug
          hervor. Bild: shu
        </p>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            {/* <Review
              rating={2}
              date='vor 15 Stunden'
              name='G*******'
              rezensionen='3 Rezensionen'
            >
              Drinnen sehr ungemütlich!! Es zieht von allen Seiten und mann
              friert die ganze Zeit 🥶 die Sitzmöglichkeit extrem unbequem und
              drinnen trostlos ausgestattet 🤔
              <br />
              Nein Danke!
            </Review> */}

            <p>
              Startpunkt: ein Parkplatz zwischen Baumarkt und Kieshaufen. Auf
              der Hauptstrasse donnern die Autos über die nahe Töss Richtung
              Winterthur, im Hintergrund thront ein Schloss. Der Burger-König
              jedoch residiert in einem schmucklosen Gebäude. Wie ein letzter
              Flügelschlag zwinkert der Chickeria-Schriftzug hinter der
              behelfsmässigen Burger-King-Blache hervor. Drinnen dominiert das
              übliche massige Dekor. Der Burger-König erhält viel Audienz. Es
              ist Mittagszeit, und zwischen Trainerhosen und Arbeiterklamotten
              drängen sich auch einige beige Rentnerjacken. Wir bestellen einen
              Vegi-Burger und bekommen stattdessen ein schwarzes Gerät in die
              Hände gedrückt. «Please come to the pick-up desk, when the beeper
              is vibrating» teilt uns der Schriftzug auf dem Gerät mit. Wir
              warten also auf den surrenden Alarmton.
            </p>

            <Review
              rating={3}
              date='vor 1 Tag'
              name='M*******'
              rezensionen='15 Rezensionen'
            >
              Ich denke das war eine kleine Portion für Erwachsene Person, ich
              werde sowieso nie wieder bei BG essen.
            </Review>

            <p>
              An den Wänden: Werbung aus guten alten Zeiten, als Kalorien noch
              nicht gezählt wurden. «A meal in itself», heisst es da, dazu
              lächelnde Gesichter. Ein schriller Alarm hallt durch den Raum.
              Kaum verklungen, schrillt ein weiteres Gerät los. Und dann noch
              eins. Und noch eins. Reizüberflutung.
            </p>

            <p>
              Nach einer hungrigen Ewigkeit – genau 14 Minuten und 13 Sekunden
              nach Bestellung – gesellt sich auch unser Gerät zum Chor der
              nervenden Buzzer hinzu. Endlich Essen.
            </p>

            <Review
              rating={1}
              date='vor eienr Woche'
              name='P*******'
              rezensionen='27 Rezensionen'
            >
              Reine Katastrophe!! Veraltete Brörchen, kalte Burger. Einfach nur
              eklig!! Wie konnte man eine leckere Chickeria gegen so etwas
              ersetzen???
            </Review>

            <p>
              Zeit für eine Zwischenbilanz: Essen, Sauberkeit und Einrichtung
              wie in jeder beliebigen Burger-King-Filiale. Das Team – ehemalige
              Chickeria-Mitarbeiterinnen und -Mitarbeiter – braucht wohl aber
              noch etwas Zeit, um in die Gänge zu kommen.
            </p>

            <List
              title='Burger-King-Restaurants mit den schlechtesten Bewertungen'
              data={[
                ['Pfungen', 'ChIJpRXKenadmkcRtTTqA-2qtKo', 30, 2.1],
                [
                  'Winterthur, Untertor',
                  'ChIJR1BjBguZmkcRbm3a3wgTYmw',
                  62,
                  3.3
                ],
                ['Flughafen', 'ChIJf9HN3lZ1kEcRDJqSlYZUt8M', 369, 3.4],
                ['Hinwil', 'ChIJY3R5JKi5mkcRaa25Uh_dThE', 75, 3.5],
                ['Volketswil', 'ChIJOf99WmOjmkcRqovJuYX13cA', 155, 3.6]
              ]}
            />

            <p>
              Und was meint Burger King dazu? Bekannt waren dem Unternehmen die
              negativen Bewertungen nicht. «Wir schätzen jedes Kundenfeedback
              und nehmen es sehr ernst», teilt eine Mediensprecherin mit. Im
              Durchschnitt hätten sie mehr als 600 Bewertungen pro Restaurant
              auf Google, erklären sie weiter, die Filiale in Pfungen habe
              bisher nur 30 Bewertungen erhalten. «Trotzdem sind wir überrascht,
              dass das BK Pfungen so schlecht abschneidet.» Das Unternehmen will
              der Situation auf den Grund gehen und ist mit dem Restaurantleiter
              in Kontakt getreten. «Gerade in einem neuen Geschäft ist es
              schwierig, sicherzustellen, dass alle Prozesse von Anfang an
              vorhanden sind und der Betrieb reibungslos läuft.»
            </p>

            <h4>McDonald’s und ein zerdonnertes Glas</h4>
            <p>
              Der Burger King in Pfungen sucht noch seine Routine. Im McDonald’s
              am Stadelhofen ist sie definitiv eingekehrt. 2005 wurde das
              Restaurant eröffnet. Als Mischung aus Raumschiff Enterprise und
              überdurchschnittlich farbenfrohem Intercity-Abteil beschrieb die
              «Neue Zürcher Zeitung» damals das Interieur. 
            </p>

            <Review
              rating={1}
              date='vor 4 Wochen'
              name='K******'
              rezensionen='1 Rezension'
            >
              Ich wollte mir heute auf gechillte Basis einen normalen
              Cheeseburger hollen. Habe dies getan und wollte ihn essen. Was ich
              darin gefunden habe waren eine enorme Menge an Ketchup und
              Haare.Der Käse war auch schon getrocknet (habe ihn natürlich in
              denn Müll geschmissen da ich kein bock auf AIDS habe). Nach dieser
              erfahrung ist MCdonalds für mich gestorben, wie kann man so
              unhygienisch sein und sich nicht mal um die zufriedenheit der
              Kundschaft kümmern. Hauptsache man bekommt seinen monatlichen
              harzer Lohn. Ich kann nur Jedem empfehlen investiert 5-10CHF mehr
              in das Essen, aber dafür aus einem Hygienischem Restaurant.
            </Review>

            <p>
              Wir besuchen den McEnterprise. Die Zukunft wurde von der Gegenwart
              eingeholt. Bestellung geht vergessen, unzureichender Service,
              nicht gereinigte Automaten urteilen 15 Jahre später die
              Google-Rezensorinnen. Mit 3,5 Sternen ist dies Zürichs am
              schlechtesten bewerteter McDonald’s.
            </p>
          </div>
        </div>
      </div>

      <div className='imagemiddle'>
        <img src={require('../../images/mcdonalds.jpg')} />
        <p className='bildunterschrift'>
          Ein Hungermagnet: Der McDonald's am Stadelhofen gehört zu einer der am
          meisten besuchten Burger-Filialen in Zürich. Bild: Sabina Bobst
        </p>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Wir bestaunen die Einrichtung. Nicht ihre Schönheit, sondern ihre
              Stabilität. Dieses Restaurant ist eine Foodfabrik, an virenfreien
              Tagen ist es fast Tag und Nacht geöffnet. Tausende Hinterteile
              rutschen auf dessen Stühlen umher und knallen Tablets auf die
              Tische.
            </p>

            <p>
              Von der reinen Funktionalität ablenken sollen Wandtapeten mit
              Sprayereien und Holzimitaten. Momentan wirkt das Restaurant jedoch
              eher so, als ob ein übermotivierter Polizist mit Absperrband durch
              die Räume gerast ist. Jeder Platz, der Corona-bedingt nicht
              benutzt werden darf, ist überdeutlich abgesperrt.
            </p>

            <Review
              rating={2}
              date='vor 2 Monaten'
              name='F******'
              rezensionen='3 Rezensionen'
            >
              Immer voll und langsam
            </Review>

            <p>
              Einem Halbstarken fällt sein eben erhaltenes Trinkglas – eine
              Geschenkaktion – aus der Hand. Für einige Minuten liegen die
              bunten Glasscherben wie eine sakrale Skulptur im Gang. Irgendwie
              passt sie hierhin und ist trotzdem fehl am Platz: Passend, weil
              die Gebrauchsspuren der Abertausenden Gäste deutliche Spuren
              hinterlassen hat, fehl am Platz, weil trotz allem alles sauber
              ist. Nach ein paar Minuten läuft eine Angestellte mit beissend
              weisser Bluse daran vorbei und kommt wenig später mit Schaufel und
              Besen zurück. Normalzustand wiederhergestellt.
            </p>

            <Review
              rating={2}
              date='vor 2 Monaten'
              name='J******'
              rezensionen='5 Rezensionen'
            >
              REGISTRIERUNG APP EINRICHTEN DAUERT ETWA 10 MIN. DIE MITARBEITERIN
              HATTE DAMIT AUCH GEWARTET BIS DAS ESSEN AUF DEM TABLET WAR. SUPER
              ALLES ABGEKÜHLT UND WÄREND DES ESSENS KAM SIE NOCH KONTROLLIEREN.
              ALLES VOR DEM BESTELLEN ERLEDIGEN????
            </Review>

            <p>
              Zwischenfazit: Das Restaurant ächzt merklich unter den vielen
              Gästen, die im Normalfall hierher kommen. Vielleicht hat es Ferien
              nötig? Ansonsten: eine Filiale wie viele andere auch.
            </p>
            {/* 
            <Review
              rating={3}
              date='vor 4 Monaten'
              name='M******'
              rezensionen='53 Rezensionen'
            >Interieur verschlissen und nicht so sauber, Essen war gut.
            </Review> */}

            <List
              title='McDonalds-Restaurants mit den schlechtesten Bewertungen'
              data={[
                [
                  'Zürich, Stadelhofen',
                  'ChIJWVobtKygmkcRjf-dHUI1l2c',
                  1270,
                  3.5
                ],
                ['Uster', 'ChIJxyxInaikmkcRcZZTpdfcKTA', 740, 3.6],
                ['Oerlikon', 'ChIJn_wpDIYKkEcRdS5XEgHFIO0', 830, 3.6],
                ['Winterthur, Grüze', 'ChIJg9sXP5KZmkcRnHTqP0y4ZPE', 895, 3.6],
                ['Dielsdorf', 'ChIJ9QnYmHBzkEcRJOOFoKwI5Ic', 635, 3.6]
              ]}
            />

            <p>
              Und was denkt McDonald’s? «Jeden Tag essen rund 300’000 Gäste in
              unseren 170 Restaurants in der Schweiz» heisst es seitens der
              Medienstelle. «Und natürlich lesen wir auch regelmässig
              Onlinerezensionen.» Über eigene Feedback-Kanäle hat gemäss
              McDonald’s das Restaurant am Stadelhofen im Durchschnitt gutes
              Feedback erhalten. «Es fällt uns kein Unterschied zu anderen
              Restaurants in der Stadt Zürich auf.» Die Bewertungen würden sich
              breit streuen – von Gästen, die sich in Bahnhofsnähe einen noch
              schnelleren Service wünschen, bis zu Gästen, die Freundlichkeit
              und Schnelligkeit des Serviceteams am Stadelhofen loben würden.
              «Wir können aber kein Muster erkennen.»
            </p>

            <h4>Kopf-an-Kopf-Rennen</h4>
            <p>
              Im Zürcher Vergleich liefern sich die beiden Burger-Riesen ein
              Kopf-an-Kopf-Rennen. McDonald’s-Filialen werden durchschnittlich
              mit 3,7 Sternen bewertet, jene von Burger King mit 3,6. Die beiden
              besuchten Filialen: deutliche Ausreisser.
            </p>
          </div>
        </div>
      </div>

      <Highlights title='McDonalds- und Burger-King-Restaurants mit den besten Bewertungen' />

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text disclaimer'>
            <h3 style={{ margin: '0px 10px 10px 0' }}>Methodik</h3>
            Ausgewertet wurden alle Geschäfte mit den Suchbegriffen «McDonalds»
            sowie «Burger King». Die Liste wurde händisch bereinigt.
            Berücksichtigt wurden nur Geschäfte mit mehr als 10 Bewertungen.
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        credits={[['Text & Entwicklung', 'Simon Huwiler']]}
        hidePortfolioTeaser
        hideUserFeedback
      >
        <More id={ARTICLE_ID} />
      </Footer>
    </div>
  )
}
